import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Colors } from 'modules/theme';
import {
  PanelContainer,
  PanelScroll,
  GroupHeader,
  OptionRow,
  OptionIcon,
  OptionTextWrap,
  OptionLabel,
  OptionSubtitle,
  EmptyState,
  FooterHint,
} from './styled';

const TYPE_META = {
  brand: { label: 'Brands', icon: 'B', bg: Colors.blue },
  account: { label: 'Accounts', icon: 'A', bg: Colors.lightBlue },
  location: { label: 'Locations', icon: 'L', bg: Colors.green },
  city: { label: 'Cities', icon: 'C', bg: Colors.yellow },
  contact: { label: 'Contacts', icon: 'P', bg: Colors.gray6 },
};

export default class SuggestionPanel extends Component {
  getPortalTarget() {
    if (typeof document === 'undefined') return null;
    let target = document.getElementById('smart-search-portal');
    if (!target) {
      target = document.createElement('div');
      target.setAttribute('id', 'smart-search-portal');
      document.body.appendChild(target);
    }
    return target;
  }

  render() {
    const {
      anchorRect,
      groups,
      flatItems,
      activeIndex,
      loading,
      query,
      onPick,
      onMouseDownCapture,
    } = this.props;
    const target = this.getPortalTarget();
    if (!target || !anchorRect) return null;

    const { left, bottom, width } = anchorRect;
    const top = bottom + 6;

    const hasAny = flatItems.length > 0;

    const panel = (
      <PanelContainer style={{ left, top, width, minWidth: 320 }} onMouseDown={onMouseDownCapture}>
        <PanelScroll>
          {!hasAny && (
            <EmptyState>
              {loading
                ? 'Searching…'
                : query.length < 2
                ? 'Type at least 2 characters to search'
                : `No matches for "${query}"`}
            </EmptyState>
          )}
          {hasAny &&
            groups.map(group => (
              <div key={group.type}>
                <GroupHeader>{TYPE_META[group.type].label}</GroupHeader>
                {group.items.map(item => {
                  const active = activeIndex === item.__flatIndex;
                  const meta = TYPE_META[group.type];
                  return (
                    <OptionRow
                      key={`${group.type}-${item.id || item.value || item.label}`}
                      active={active}
                      onClick={() => onPick(item)}
                      onMouseEnter={() => this.props.onHover(item.__flatIndex)}
                    >
                      <OptionIcon bg={meta.bg}>{meta.icon}</OptionIcon>
                      <OptionTextWrap>
                        <OptionLabel>{item.label}</OptionLabel>
                        {item.subtitle && <OptionSubtitle>{item.subtitle}</OptionSubtitle>}
                      </OptionTextWrap>
                    </OptionRow>
                  );
                })}
              </div>
            ))}
        </PanelScroll>
        {hasAny && (
          <FooterHint>
            <span>↑↓ navigate · Enter select · Esc close</span>
            <span>⌫ remove last chip</span>
          </FooterHint>
        )}
      </PanelContainer>
    );

    return ReactDOM.createPortal(panel, target);
  }
}

SuggestionPanel.propTypes = {
  activeIndex: PropTypes.number,
  anchorRect: PropTypes.object,
  flatItems: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onHover: PropTypes.func.isRequired,
  onMouseDownCapture: PropTypes.func,
  onPick: PropTypes.func.isRequired,
  query: PropTypes.string,
};
